import React from 'react';
import { Navigate } from 'react-router-dom';
// lib
import { isLogin } from '../lib/auth';
// components
import Sidebar from '../components/Sidebar';

const isSidebar = (component) => {
    return (
        <div className="flex h-screen bg-gray-100">
            <Sidebar />
            <div className="flex-1 overflow-auto">
                {component}
            </div>
        </div>
    )
}

const ConditionRouter = ({ type, isSideMenu, children }) => {
    const { status: loginStatus } = isLogin()
    if (type === 'private' && loginStatus === false) return <Navigate to="/login" />
    else if (type === 'auth' && loginStatus === true) return <Navigate to="/dashboard" />
    return isSideMenu === true ? isSidebar(children) : children;
}

export default ConditionRouter;